<video #target class="video-js vjs-default-skin" controls preload="none" playsinline>
    <!-- Forrásokat és típust szabad itt megadni -->
</video>
<div class="d-flex gap-2 p-2" *ngIf="isTablet$ | async">
  <fa-icon [icon]="faPlay" *ngIf="!playing" (click)="playPause()" style="cursor: pointer;font-size:30px;"></fa-icon>
  <fa-icon [icon]="faPause" *ngIf="playing" (click)="playPause()" style="cursor: pointer;font-size:30px;"></fa-icon>
  <fa-icon [icon]="faWindow" (click)="fullScreen()" style="cursor: pointer;font-size:30px;"></fa-icon>
  <fa-icon [icon]="faWindowRestore" (click)="pip()" style="cursor: pointer;font-size:30px;"></fa-icon>
</div>
